<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'Input',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'maxlength', 'id', 'type', 'dense', 'readonly', 'disabled'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-text-field
    class="py-0 my-0"
    v-model="model"
    :dense="dense"
    :id="id"
    :maxlength="maxlength || 64"
    :placeholder="placeholder"
    :rules="rules"
    outlined
    :label="label"
    :type ="type || 'text'"
    :readonly="readonly"
    :disabled="disabled"
  />
</template>
